import { Routes, Route } from 'react-router-dom';
import Test from './pages/Test';
//import Result from './pages/Result';
import './App.css';
import Glavn from './pages/Glavn';
import Result from './pages/Result';
import INTJ from './pages/INTJ';
import INTP from './pages/INTP';
import ENTJ from './pages/ENTJ';
import ENTP from './pages/ENTP';
import INFJ from './pages/INFJ';
import INFP from './pages/INFP';
import ENFJ from './pages/ENFJ';
import ENFP from './pages/ENFP';
import ISTJ from './pages/ISTJ';
import ISFJ from './pages/ISFJ';
import ESTJ from './pages/ESTJ';
import ESFJ from './pages/ESFJ';
import ISTP from './pages/ISTP';
import ISFP from './pages/ISFP';
import ESTP from './pages/ESTP';
import ESFP from './pages/ESFP';
import Pochta from './pages/Pochta';

function App() {
 return (
 <div className="App">
      <Routes>
 <Route path="/" element={<Glavn />} />
  <Route path="/test" element={<Test />} />
  <Route path="/result" element={<Result />} />

  <Route path="/intj" element={<INTJ />} />
  <Route path="/intp" element={<INTP />} />
  <Route path="/entj" element={<ENTJ />} />
  <Route path="/entp" element={<ENTP />} />
  <Route path="/infj" element={<INFJ />} />
  <Route path="/intj" element={<INTJ />} />
  <Route path="/infp" element={<INFP />} />
  <Route path="/enfj" element={<ENFJ />} />
  <Route path="/enfp" element={<ENFP />} />
  <Route path="/istj" element={<ISTJ />} />
  <Route path="/isfj" element={<ISFJ />} />
  <Route path="/estj" element={<ESTJ />} />
  <Route path="/esfj" element={<ESFJ />} />
  <Route path="/istp" element={<ISTP />} />
  <Route path="/isfp" element={<ISFP />} />
  <Route path="/estp" element={<ESTP />} />
  <Route path="/esfp" element={<ESFP />} />
  <Route path="/pochta" element={<Pochta />} />
      </Routes>
    </div>
  );
}

export default App;
